import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export type ConfirmDialogTone = 'primary' | 'danger' | 'warning' | 'success';

export interface ConfirmDialogData {
  title: string;
  message: string;
  details?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: ConfirmDialogTone;
  /** Örökölt mező: a régi FontAwesome osztálynevek ide kerülhetnek, de a
   *  megjelenő ikont mindig a tone határozza meg (Stokker SVG készlet). */
  icon?: string;
  checkboxLabel?: string;
  checkboxDefault?: boolean;
  /** Második, opcionális jelölőnégyzet (pl. „a számlát is sztornózzuk"). */
  secondaryCheckboxLabel?: string;
  secondaryCheckboxDefault?: boolean;
}

export interface ConfirmDialogResult {
  confirmed: boolean;
  checkboxChecked: boolean;
  secondaryCheckboxChecked: boolean;
}

const SVG_OPEN = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">';
const SVG_CLOSE = '</svg>';

const TONE_ICONS: Record<ConfirmDialogTone, string> = {
  danger: '<path d="M12 3 L22 20 H2 Z"></path><line x1="12" y1="10" x2="12" y2="15"></line><circle cx="12" cy="17.5" r="0.6" fill="currentColor"></circle>',
  warning: '<path d="M12 3 L20 6.5 V12 C20 16.6 16.6 19.8 12 21 C7.4 19.8 4 16.6 4 12 V6.5 Z"></path><line x1="12" y1="9" x2="12" y2="13.5"></line><circle cx="12" cy="16" r="0.6" fill="currentColor"></circle>',
  success: '<circle cx="12" cy="12" r="9"></circle><polyline points="8,12.5 11,15.5 16.5,9.5"></polyline>',
  primary: '<circle cx="12" cy="12" r="9"></circle><line x1="12" y1="11" x2="12" y2="16.5"></line><circle cx="12" cy="7.8" r="0.6" fill="currentColor"></circle>',
};

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ConfirmDialogComponent {
  checkboxChecked = this.data.checkboxDefault ?? false;
  secondaryCheckboxChecked = this.data.secondaryCheckboxDefault ?? false;
  readonly toneIcon: SafeHtml;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private dialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult>,
    sanitizer: DomSanitizer,
  ) {
    this.toneIcon = sanitizer.bypassSecurityTrustHtml(SVG_OPEN + TONE_ICONS[this.tone] + SVG_CLOSE);
  }

  get tone(): ConfirmDialogTone {
    return this.data.tone || 'primary';
  }

  get confirmLabel(): string {
    return this.data.confirmLabel || 'Megerősítés';
  }

  get cancelLabel(): string {
    return this.data.cancelLabel || 'Mégse';
  }

  cancel(): void {
    this.dialogRef.close({
      confirmed: false,
      checkboxChecked: this.checkboxChecked,
      secondaryCheckboxChecked: this.secondaryCheckboxChecked,
    });
  }

  confirm(): void {
    this.dialogRef.close({
      confirmed: true,
      checkboxChecked: this.checkboxChecked,
      secondaryCheckboxChecked: this.secondaryCheckboxChecked,
    });
  }
}
